import React,{useState,useEffect} from 'react'
import portalServices from '../portalServices';
import moment from 'moment';
import { Dialog, DialogActions, DialogContent } from '@mui/material';

function VisitorReportingTime({tokenDetails}) {

    const [dialogStatus,setDialogStatus] = useState(false);
    const [queueWorkingHours,setQueueWorkingHours] = useState(null);
    const [reportingTime,setReportingTime] = useState("Check Display Board");

    function addMinutesToTime(timeString, minutesToAdd, inputFormat = 'HH:mm', outputFormat = 'hh:mm A') {
        minutesToAdd = minutesToAdd - 15 // Subtract 10 minutes more to as user to be there 10 minutes earlier
        const momentTime = moment(timeString, inputFormat);
        momentTime.add(minutesToAdd, 'minutes');
        return momentTime.format(outputFormat);
      }

    const calculateReportingtime = (queueWorkingHours) =>{


        //console.log("calculating working hours for",tokenDetails.queueId) 
        let dayIndex = moment(tokenDetails.checkinDate).day()-1;  // 0 for sunday 1 for monday 6 saturday then -1 for index in our array list;
        if(dayIndex === -1) { //  index # 5 for saturday / 6 for sunday
            dayIndex = 6;
        } 
        console.log("day index for "+tokenDetails.queueId+" checkindate : "+tokenDetails.checkinDate+" => "+dayIndex)
        //console.log(queueWorkingHours);
        //console.log("tokenDetails",tokenDetails);
        //console.log("avgProcessTime",tokenDetails.avgProcessTime)
        //console.log("stations",tokenDetails.stations)
        let position = Math.ceil(tokenDetails.tokenNo / tokenDetails.stations);
        let eta = (position*tokenDetails.avgProcessTime) - tokenDetails.avgProcessTime;
        //console.log("position",position);
        //console.log("eta",eta);
        //console.log("starts at",queueWorkingHours[dayIndex].dayStart);
        let et  = addMinutesToTime(queueWorkingHours[dayIndex].dayStart,eta);
        //console.log("et",et);
        setReportingTime(et)
    }

    const getReportingTime = () =>{
        //setDialogStatus(true);
        if(tokenDetails.checkinDate !== moment(tokenDetails.created_at).format("YYYY-MM-DD")){
            setQueueWorkingHours(null);
            portalServices.getQueueWorkingHoursList(tokenDetails.queueId).then(res=>{
                setQueueWorkingHours(res.data);
                calculateReportingtime(res.data);
            }).catch(error=>{
            })
        }
       
    }

    const getWeekDayName = (dayNo) =>{
        let weekDays = ["","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
        return weekDays[dayNo];
    }

    useEffect(()=>{
        getReportingTime();
    },[tokenDetails])

    return (
        <>
            {tokenDetails.checkinDate !== moment(tokenDetails.created_at).format("YYYY-MM-DD") &&
                <>
                    <button className='btn btn-warning btn-lg'>Reporting Time : {moment(tokenDetails.checkinDate).format("ddd")}, {moment(tokenDetails.checkinDate).format("LL")}, {reportingTime}</button>
                    <div class="alert alert-warning mt-2" >
                        <strong>For your convenience!</strong>
                        <p> This Reporting time is calculated on the basis of average processing time.<br/><i> This time may vary because of various exception.</i></p>
                        <p>For more details <b>Check Display Board</b> at office on scheduled date.</p>


                        <strong>आपकी सुविधा के लिए!</strong>
                        <p>यह रिपोर्टिंग समय औसत प्रोसेसिंग समय के आधार पर निर्धारित किया गया है।<br/><i>यह समय विभिन्न अपवादों के कारण बदल सकता है।</i></p>
                        <p>अधिक जानकारी के लिए निर्धारित तिथि पर कार्यालय में डिस्प्ले बोर्ड देखें।</p>
                    </div>
                    
                </>
            }
            {tokenDetails.checkinDate == moment(tokenDetails.created_at).format("YYYY-MM-DD") &&
                <button className='btn btn-warning btn-lg mb-2'>Reporting Time : {reportingTime}</button>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
            >
                <DialogContent>
                    
                </DialogContent>
                <DialogActions><button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)} >Close</button></DialogActions>
            </Dialog>
        </>
    )
}

export default VisitorReportingTime

                        {/*
                            <div className='row'>
                                {queueWorkingHours && 
                                    <div className='col-md-12'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th>Day</th>
                                                    <th>Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {queueWorkingHours.map(day=> day.dayStatus == 1 &&
                                                    <tr key={day.dayNo}>
                                                        <td>{ getWeekDayName(day.dayNo)}</td>
                                                        <td>
                                                           <span className='fw-bold'> { moment( moment().format("YYYY-MM-DD")+" "+day.dayStart).format("h:mm A")} </span>
                                                            to 
                                                            <span className='fw-bold'> { moment( moment().format("YYYY-MM-DD")+" "+day.dayEnd).format("h:mm A")} </span>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                                <div className='col-md-12'>
                                    <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)} >Close</button>
                                </div>
                            </div>

                            */}